import imageCompression from "browser-image-compression";
import { DEFAULT_COMPRESSION_OPTIONS } from "../constants/imageUpload";

export const compression = async (
  imageFile,
  options = DEFAULT_COMPRESSION_OPTIONS,
) => {
  console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

  try {
    const compressedFile = await imageCompression(imageFile, options);
    console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`); // smaller than maxSizeMB

    return compressedFile;
  } catch (error) {
    console.log(error);
  }
};
